import { render, staticRenderFns } from "./editLicenseForm.vue?vue&type=template&id=39377d40&scoped=true"
import script from "./editLicenseForm.vue?vue&type=script&lang=js"
export * from "./editLicenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39377d40",
  null
  
)

export default component.exports